import normalizeUrl from "normalize-url";

/**
 * Whether the value is a single absolute http(s) url — e.g. a linkfield value.
 * Multi-value strings (urls joined with separators/whitespace) are rejected:
 * the URL parser silently strips newlines, so a joined value would otherwise
 * produce one mangled link.
 */
export function isHttpUrlValue(value: string): boolean {
  return /^(http|https):\/\/\S+$/.test(value) && isValidUrl(value);
}

/**
 * Extracts every absolute http(s) url from a field value. Multi-value fields
 * arrive as a single string with the urls joined by a separator (newline or
 * comma) — each one is returned separately, with trailing punctuation from
 * the separator stripped.
 */
export function extractHttpUrls(value: string): string[] {
  const matches = value.match(/https?:\/\/\S+/g) ?? [];
  return matches
    .map((url) => url.replace(/[,;]+$/, ""))
    .filter((url) => isHttpUrlValue(url));
}

export function isValidUrl(value: string): boolean {
  try {
    const normalizedUrl = normalizeUrl(value, {
      defaultProtocol: "https",
      stripWWW: false,
    });
    const parsedUrl = new URL(normalizedUrl);
    const segments = parsedUrl.host.split(".");

    return segments.length > 1;
  } catch {
    return false;
  }
}
